import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('nl_cart') || '[]'); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('nl_cart', JSON.stringify(items));
  }, [items]);

  const addToCart = (product, qty = 1) => {
    setItems(prev => {
      const found = prev.find(i => i.product_id === product.id);
      if (found) {
        return prev.map(i => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        product_id: product.id,
        name: product.name,
        price: product.price,
        image: (product.images && product.images[0]) || '',
        quantity: qty,
      }];
    });
  };

  const updateQty = (product_id, quantity) => {
    if (quantity <= 0) return removeFromCart(product_id);
    setItems(prev => prev.map(i => i.product_id === product_id ? { ...i, quantity } : i));
  };

  const removeFromCart = (product_id) => setItems(prev => prev.filter(i => i.product_id !== product_id));
  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addToCart, updateQty, removeFromCart, clearCart, count, total }}>
      {children}
    </CartContext.Provider>
  );
};
